/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateStatusEnum } from './DateStatusEnum';
import {
    DateStatusEnumFromJSON,
    DateStatusEnumFromJSONTyped,
    DateStatusEnumToJSON,
    DateStatusEnumToJSONTyped,
} from './DateStatusEnum';
import type { SharedSettlement } from './SharedSettlement';
import {
    SharedSettlementFromJSON,
    SharedSettlementFromJSONTyped,
    SharedSettlementToJSON,
    SharedSettlementToJSONTyped,
} from './SharedSettlement';
import type { StatusAb7Enum } from './StatusAb7Enum';
import {
    StatusAb7EnumFromJSON,
    StatusAb7EnumFromJSONTyped,
    StatusAb7EnumToJSON,
    StatusAb7EnumToJSONTyped,
} from './StatusAb7Enum';
import type { BookingTerms } from './BookingTerms';
import {
    BookingTermsFromJSON,
    BookingTermsFromJSONTyped,
    BookingTermsToJSON,
    BookingTermsToJSONTyped,
} from './BookingTerms';

/**
 * Full serializer for Hold model with all fields and nested relationships.
 * @export
 * @interface Hold
 */
export interface Hold {
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly id: string;
    /**
     *
     * @type {boolean}
     * @memberof Hold
     */
    readonly canManage: boolean;
    /**
     *
     * @type {number}
     * @memberof Hold
     */
    readonly hostTeam: number;
    /**
     *
     * @type {number}
     * @memberof Hold
     */
    readonly showTeam: number | null;
    /**
     *
     * @type {BookingTerms}
     * @memberof Hold
     */
    bookingTerms?: BookingTerms;
    /**
     *
     * @type {SharedSettlement}
     * @memberof Hold
     */
    sharedSettlement?: SharedSettlement;
    /**
     *
     * @type {string}
     * @memberof Hold
     */
    hostNotes?: string;
    /**
     *
     * @type {number}
     * @memberof Hold
     */
    readonly bookingRevision: number;
    /**
     *
     * @type {Date}
     * @memberof Hold
     */
    readonly acceptedAt: Date | null;
    /**
     * Title for the new show when creating a hold without an existing show.
     * @type {string}
     * @memberof Hold
     */
    title?: string;
    /**
     * Stage for this hold
     * @type {string}
     * @memberof Hold
     */
    stage: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly stageName: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly stageVenueName: string;
    /**
     * Date of the hold
     * @type {Date}
     * @memberof Hold
     */
    holdDate: Date;
    /**
     * Team that placed the hold
     * @type {number}
     * @memberof Hold
     */
    promoterTeam: number;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly promoterTeamName: string;
    /**
     * Show associated with this hold (for multi-day holds)
     * @type {string}
     * @memberof Hold
     */
    show?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly showTitle: string | null;
    /**
     * Position in the hold queue (1 = first hold, 2 = second hold, etc.)
     * @type {number}
     * @memberof Hold
     */
    readonly holdPosition: number;
    /**
     * Current status of the hold
     * 
     * * `requested` - Awaiting host acceptance
     * * `declined` - Declined by host
     * * `pending` - Pending
     * * `challenged` - Challenged
     * * `confirmed` - Confirmed
     * * `standby` - Standby
     * * `released` - Released
     * * `expired` - Expired
     * * `cancelled` - Cancelled
     * @type {StatusAb7Enum}
     * @memberof Hold
     */
    status?: StatusAb7Enum;
    /**
     * Status of the date itself
     * 
     * * `open` - Open
     * * `held` - Held
     * * `confirmed` - Confirmed
     * * `unavailable` - Unavailable
     * @type {DateStatusEnum}
     * @memberof Hold
     */
    dateStatus?: DateStatusEnum;
    /**
     * When this hold was challenged
     * @type {Date}
     * @memberof Hold
     */
    challengedAt?: Date | null;
    /**
     * Team that challenged this hold
     * @type {number}
     * @memberof Hold
     */
    challengerTeam?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly challengerTeamName: string | null;
    /**
     * Deadline to respond to challenge (typically 24-48 hours)
     * @type {Date}
     * @memberof Hold
     */
    challengeResponseDeadline?: Date | null;
    /**
     * When this hold expires if not confirmed or challenged (14 days)
     * @type {Date}
     * @memberof Hold
     */
    expiresAt?: Date | null;
    /**
     * Deadline for pending holds to be finalized when part of a multi-date show with confirmed dates (24 hours)
     * @type {Date}
     * @memberof Hold
     */
    decisionDeadline?: Date | null;
    /**
     * Internal notes about this hold
     * @type {string}
     * @memberof Hold
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly isExpired: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly hasDecisionDeadline: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly timeUntilExpiration: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly timeUntilChallengeDeadline: string;
    /**
     * 
     * @type {Date}
     * @memberof Hold
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Hold
     */
    readonly updatedAt: Date;
    /**
     * Return whether the hold is considered active (not released or expired).
     * @type {boolean}
     * @memberof Hold
     */
    readonly isActive: boolean;
    /**
     * Load-in time for this specific date
     * @type {string}
     * @memberof Hold
     */
    loadInTime?: string | null;
    /**
     * Soundcheck time for this specific date
     * @type {string}
     * @memberof Hold
     */
    soundcheckTime?: string | null;
    /**
     * Time doors open for this specific date
     * @type {string}
     * @memberof Hold
     */
    doorsTime?: string | null;
    /**
     * Show start time for this specific date
     * @type {string}
     * @memberof Hold
     */
    showTime?: string | null;
    /**
     * Show end time for this specific date
     * @type {string}
     * @memberof Hold
     */
    endTime?: string | null;
    /**
     * Actual attendance for this specific date
     * @type {number}
     * @memberof Hold
     */
    attendance?: number | null;
    /**
     * Calculate total tickets sold from ticket_revenue_items.
     * @type {number}
     * @memberof Hold
     */
    readonly ticketsSold: number;
    /**
     * Show-specific capacity limit for this date (may differ from venue capacity)
     * @type {number}
     * @memberof Hold
     */
    showCapacity?: number | null;
    /**
     * Line-item ticket sales (e.g., [{'type': 'presale', 'name': 'Early Bird', 'quantity': 50, 'price': '25.00'}])
     * @type {any}
     * @memberof Hold
     */
    ticketRevenueItems?: any | null;
    /**
     * Total ticket sales revenue for this specific date (auto-calculated)
     * @type {string}
     * @memberof Hold
     */
    ticketRevenue?: string | null;
    /**
     * Bar/concessions revenue for this specific date
     * @type {string}
     * @memberof Hold
     */
    barRevenue?: string | null;
    /**
     * Other revenue (merch, parking, etc.) for this specific date
     * @type {string}
     * @memberof Hold
     */
    otherRevenue?: string | null;
    /**
     * Line-item expenses (e.g., [{'name': 'Security', 'amount': '100.00'}])
     * @type {any}
     * @memberof Hold
     */
    expenseItems?: any | null;
    /**
     * Total production/staffing expenses for this specific date
     * @type {string}
     * @memberof Hold
     */
    totalExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly totalRevenue: string;
    /**
     * 
     * @type {string}
     * @memberof Hold
     */
    readonly netProfit: string;
    /**
     * Whether this specific date has been financially settled
     * @type {boolean}
     * @memberof Hold
     */
    isSettled?: boolean;
    /**
     * Date this specific show instance was settled
     * @type {Date}
     * @memberof Hold
     */
    settlementDate?: Date | null;
    /**
     * Notes about settlement for this specific date
     * @type {string}
     * @memberof Hold
     */
    settlementNotes?: string;
}



/**
 * Check if a given object implements the Hold interface.
 */
export function instanceOfHold(value: object): value is Hold {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('canManage' in value) || value['canManage'] === undefined) return false;
    if (!('hostTeam' in value) || value['hostTeam'] === undefined) return false;
    if (!('showTeam' in value) || value['showTeam'] === undefined) return false;
    if (!('bookingRevision' in value) || value['bookingRevision'] === undefined) return false;
    if (!('acceptedAt' in value) || value['acceptedAt'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('stageName' in value) || value['stageName'] === undefined) return false;
    if (!('stageVenueName' in value) || value['stageVenueName'] === undefined) return false;
    if (!('holdDate' in value) || value['holdDate'] === undefined) return false;
    if (!('promoterTeam' in value) || value['promoterTeam'] === undefined) return false;
    if (!('promoterTeamName' in value) || value['promoterTeamName'] === undefined) return false;
    if (!('showTitle' in value) || value['showTitle'] === undefined) return false;
    if (!('holdPosition' in value) || value['holdPosition'] === undefined) return false;
    if (!('challengerTeamName' in value) || value['challengerTeamName'] === undefined) return false;
    if (!('isExpired' in value) || value['isExpired'] === undefined) return false;
    if (!('hasDecisionDeadline' in value) || value['hasDecisionDeadline'] === undefined) return false;
    if (!('timeUntilExpiration' in value) || value['timeUntilExpiration'] === undefined) return false;
    if (!('timeUntilChallengeDeadline' in value) || value['timeUntilChallengeDeadline'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('ticketsSold' in value) || value['ticketsSold'] === undefined) return false;
    if (!('totalRevenue' in value) || value['totalRevenue'] === undefined) return false;
    if (!('netProfit' in value) || value['netProfit'] === undefined) return false;
    return true;
}

export function HoldFromJSON(json: any): Hold {
    return HoldFromJSONTyped(json, false);
}

export function HoldFromJSONTyped(json: any, ignoreDiscriminator: boolean): Hold {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'canManage': json['can_manage'],
        'hostTeam': json['host_team'],
        'showTeam': json['show_team'],
        'bookingTerms': json['booking_terms'] == null ? undefined : BookingTermsFromJSON(json['booking_terms']),
        'sharedSettlement': json['shared_settlement'] == null ? undefined : SharedSettlementFromJSON(json['shared_settlement']),
        'hostNotes': json['host_notes'] == null ? undefined : json['host_notes'],
        'bookingRevision': json['booking_revision'],
        'acceptedAt': (json['accepted_at'] == null ? null : new Date(json['accepted_at'])),
        'title': json['title'] == null ? undefined : json['title'],
        'stage': json['stage'],
        'stageName': json['stage_name'],
        'stageVenueName': json['stage_venue_name'],
        'holdDate': (new Date(json['hold_date'])),
        'promoterTeam': json['promoter_team'],
        'promoterTeamName': json['promoter_team_name'],
        'show': json['show'] == null ? undefined : json['show'],
        'showTitle': json['show_title'],
        'holdPosition': json['hold_position'],
        'status': json['status'] == null ? undefined : StatusAb7EnumFromJSON(json['status']),
        'dateStatus': json['date_status'] == null ? undefined : DateStatusEnumFromJSON(json['date_status']),
        'challengedAt': json['challenged_at'] == null ? undefined : (new Date(json['challenged_at'])),
        'challengerTeam': json['challenger_team'] == null ? undefined : json['challenger_team'],
        'challengerTeamName': json['challenger_team_name'],
        'challengeResponseDeadline': json['challenge_response_deadline'] == null ? undefined : (new Date(json['challenge_response_deadline'])),
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'decisionDeadline': json['decision_deadline'] == null ? undefined : (new Date(json['decision_deadline'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'isExpired': json['is_expired'],
        'hasDecisionDeadline': json['has_decision_deadline'],
        'timeUntilExpiration': json['time_until_expiration'],
        'timeUntilChallengeDeadline': json['time_until_challenge_deadline'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'isActive': json['is_active'],
        'loadInTime': json['load_in_time'] == null ? undefined : json['load_in_time'],
        'soundcheckTime': json['soundcheck_time'] == null ? undefined : json['soundcheck_time'],
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'ticketsSold': json['tickets_sold'],
        'showCapacity': json['show_capacity'] == null ? undefined : json['show_capacity'],
        'ticketRevenueItems': json['ticket_revenue_items'] == null ? undefined : json['ticket_revenue_items'],
        'ticketRevenue': json['ticket_revenue'] == null ? undefined : json['ticket_revenue'],
        'barRevenue': json['bar_revenue'] == null ? undefined : json['bar_revenue'],
        'otherRevenue': json['other_revenue'] == null ? undefined : json['other_revenue'],
        'expenseItems': json['expense_items'] == null ? undefined : json['expense_items'],
        'totalExpenses': json['total_expenses'] == null ? undefined : json['total_expenses'],
        'totalRevenue': json['total_revenue'],
        'netProfit': json['net_profit'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
        'settlementDate': json['settlement_date'] == null ? undefined : (new Date(json['settlement_date'])),
        'settlementNotes': json['settlement_notes'] == null ? undefined : json['settlement_notes'],
    };
}

  export function HoldToJSON(json: any): Hold {
      return HoldToJSONTyped(json, false);
  }

  export function HoldToJSONTyped(value?: Omit<Hold, 'id'|'can_manage'|'host_team'|'show_team'|'booking_revision'|'accepted_at'|'stage_name'|'stage_venue_name'|'promoter_team_name'|'show_title'|'hold_position'|'challenger_team_name'|'is_expired'|'has_decision_deadline'|'time_until_expiration'|'time_until_challenge_deadline'|'created_at'|'updated_at'|'is_active'|'tickets_sold'|'total_revenue'|'net_profit'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_terms': BookingTermsToJSON(value['bookingTerms']),
        'shared_settlement': SharedSettlementToJSON(value['sharedSettlement']),
        'host_notes': value['hostNotes'],
        'title': value['title'],
        'stage': value['stage'],
        'hold_date': ((value['holdDate']).toISOString().substring(0,10)),
        'promoter_team': value['promoterTeam'],
        'show': value['show'],
        'status': StatusAb7EnumToJSON(value['status']),
        'date_status': DateStatusEnumToJSON(value['dateStatus']),
        'challenged_at': value['challengedAt'] == null ? undefined : ((value['challengedAt'] as any).toISOString()),
        'challenger_team': value['challengerTeam'],
        'challenge_response_deadline': value['challengeResponseDeadline'] == null ? undefined : ((value['challengeResponseDeadline'] as any).toISOString()),
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
        'decision_deadline': value['decisionDeadline'] == null ? undefined : ((value['decisionDeadline'] as any).toISOString()),
        'notes': value['notes'],
        'load_in_time': value['loadInTime'],
        'soundcheck_time': value['soundcheckTime'],
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'attendance': value['attendance'],
        'show_capacity': value['showCapacity'],
        'ticket_revenue_items': value['ticketRevenueItems'],
        'ticket_revenue': value['ticketRevenue'],
        'bar_revenue': value['barRevenue'],
        'other_revenue': value['otherRevenue'],
        'expense_items': value['expenseItems'],
        'total_expenses': value['totalExpenses'],
        'is_settled': value['isSettled'],
        'settlement_date': value['settlementDate'] == null ? undefined : ((value['settlementDate'] as any).toISOString().substring(0,10)),
        'settlement_notes': value['settlementNotes'],
    };
}
